/**
 * The ConciAir wordmark (D96), from the brand SVG in `public/brand`:
 * navy and gold on light surfaces, white and gold on navy. The square mark
 * stands in where a wordmark will not fit.
 */
export function Logo({ onNavy = false, className = 'h-7' }: { onNavy?: boolean; className?: string }) {
  return <img src={onNavy ? '/brand/conciair-white.svg' : '/brand/conciair.svg'} alt="ConciAir" className={`w-auto shrink-0 ${className}`} draggable={false} />;
}

export function Mark({ className = 'h-8 w-8' }: { className?: string }) {
  return <img src="/brand/mark.svg" alt="ConciAir" className={`shrink-0 rounded ${className}`} draggable={false} />;
}
